"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    useGoogleMapsHooks: ()=>useGoogleMapsHooks,
    handleCatctError: ()=>handleCatctError
});
const external_react_namespaceObject = require("react");
const analytics_js_namespaceObject = require("../../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const external_googleMapManager_js_namespaceObject = require("./googleMapManager.js");
const handleCatctError = (error)=>{
    analytics_js_default().logError({
        loggedFrom: 'useGoogleMapsHooks',
        message: 'Failed to initialize google maps',
        error: error?.message
    });
};
const useGoogleMapsHooks = ({ hotelPinsOnMap, locationPinsOnMap })=>{
    const hotelPinKeys = (0, external_react_namespaceObject.useMemo)(()=>Object.keys(hotelPinsOnMap), [
        hotelPinsOnMap
    ]);
    const locationPinKeys = (0, external_react_namespaceObject.useMemo)(()=>Object.keys(locationPinsOnMap), [
        locationPinsOnMap
    ]);
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (0 !== hotelPinKeys.length || 0 !== locationPinKeys.length) {
            external_googleMapManager_js_namespaceObject.mapManager.initloader();
            external_googleMapManager_js_namespaceObject.mapManager.setMap().then(()=>{
                hotelPinKeys.forEach((key)=>{
                    external_googleMapManager_js_namespaceObject.mapManager.createAdvancedMarker(hotelPinsOnMap[key]);
                });
                locationPinKeys.forEach((key)=>{
                    external_googleMapManager_js_namespaceObject.mapManager.createAdvancedMarker(locationPinsOnMap[key]);
                });
                const mergedPinsMap = {
                    ...locationPinsOnMap,
                    ...hotelPinsOnMap
                };
                external_googleMapManager_js_namespaceObject.mapManager.fitBoundsOnCurrentMap([
                    ...hotelPinKeys,
                    ...locationPinKeys
                ].map((key)=>mergedPinsMap[key])).catch((error)=>{
                    analytics_js_default().logError({
                        loggedFrom: 'useGoogleMapsHooks',
                        message: 'Failed to call fitBoundsOnCurrentMap on mapManager',
                        error: error.message
                    });
                });
                external_googleMapManager_js_namespaceObject.mapManager.fireCallbacks();
            }).catch(handleCatctError);
        }
    }, [
        hotelPinKeys.length,
        locationPinKeys.length
    ]);
};
exports.handleCatctError = __webpack_exports__.handleCatctError;
exports.useGoogleMapsHooks = __webpack_exports__.useGoogleMapsHooks;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "handleCatctError",
    "useGoogleMapsHooks"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
